export default function getResource(label, vars = []) {
    const resources = {
        title: 'Join Sephora Texts',
        description: 'to unlock exclusive access to beauty offers and updates.',
        buttonText: 'Send me Sephora Text Alerts'
    };

    return resources[label];
}
